<template>
  <div class="book-content">
    <FDBannerImg />

    <div class="container">
      <div class="navigation">
        <div class="page-cen">
          <div class="navigation-item">
            <a href="javascript:void(0)" @click="goPage('/home')">首页</a
            >&nbsp;&gt;
            <a class="active" href="javascript:void(0)">新书上架</a>
          </div>
        </div>
      </div>
      <div class="bookContainer">
        <div class="search_banner">
          <div class="search_group">
            <div class="search_left">
              <el-select v-model="searchType" style="max-width: 150px">
                <el-option
                  v-for="item in searchOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <span style="color: gray; margin: 0 20px 0 10px; font-size: 14px"
                >|</span
              >
              <svg-icon
                icon-class="search"
                style="font-size: 16px; color: #b9b9b9"
              />
              <el-input
                v-model="searchValue"
                placeholder="请输入检索关键词"
                @keyup.enter.native="handleQuery"
              />
            </div>
            <div class="search_right" @click="handleQuery">
              <svg-icon
                icon-class="search"
                style="font-size: 14px; color: #fff; margin-right: 5px"
              />
              检索
            </div>
          </div>
        </div>
        <div class="search_tip">
          <div class="total">
            <span v-if="resultFlag">根据检索词“{{ resultValue }}”，</span>
            共找到 <span style="color: #f50">{{ total }}</span> 本新书数据
          </div>
          <div class="page">
            <Pagination
              v-if="total > 0"
              background
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage"
              :page-size="pageSize"
              layout="prev, pager, next, jumper"
              :total="total"
            />
          </div>
        </div>
        <div class="book" v-if="total > 0">
          <div
            class="bookItem"
            v-for="item in dataList"
            :key="item.id"
            @click="toDetail(item)"
          >
            <div class="imgBox">
              <img :src="item.cover" :alt="item.title" />
            </div>
            <div class="infoBox">
              <div class="title">
                {{ item.title }}
              </div>
              <div class="info">
                <p class="info-item">作者：{{ item.author }}</p>
                <p class="info-item">出版社：{{ item.publisher }}</p>
                <p class="info-item">出版年：{{ item.year }}</p>
                <p class="info-item">索书号：{{ item.callNumber }}</p>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="empty">
          <img src="../../assets/empty.png" alt="" />
        </div>
        <div class="search_tip" v-if="total > 15">
          <div class="total">
            共找到 <span style="color: #023886">{{ total }}</span> 本新书数据
          </div>
          <div class="page">
            <Pagination
              v-if="total > 0"
              background
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage"
              :page-size="pageSize"
              layout="prev, pager, next, jumper"
              :total="total"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Pagination } from "element-ui";
import { post, get } from "@u/request";
import FDBannerImg from "@c//FDBannerImg";
export default {
  name: "",
  components: { FDBannerImg, Pagination },
  data() {
    return {
      logo: "",
      copyright: {},
      total: 0,
      currentPage: 1,
      pageSize: 20,
      dataList: [],
      searchType: "searchValue",
      searchValue: null,
      resultFlag: false,
      resultValue: null,
      searchOptions: [
        {
          value: "searchValue",
          label: "全部字段",
        },
        {
          value: "title",
          label: "题名",
        },
        {
          value: "publisher",
          label: "出版社",
        },

        {
          value: "author",
          label: "作者",
        },
        {
          value: "isbn",
          label: "ISBN",
        },
        {
          value: "callNumber",
          label: "索书号",
        },
        // {
        //   value: 6,
        //   label: "主题",
        // },
      ],
    };
  },
  computed: {
    // 缓存页面name
    catche() {
      return this.$store.getters.includeArr;
    },
    key() {
      return this.$router.fullPath;
    },
  },
  methods: {
    toDetail(item) {
      this.$router.push(`/bookDetail/${item.id}`);
    },
    handleQuery() {
      this.currentPage = 1;
      this.loadList();
    },
    handleCurrentChange() {
      this.loadList();
    },
    async loadList() {
      const params = {
        publish: 1,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
      };
      if (this.searchValue) {
        params[this.searchType] = this.searchValue;
        this.resultFlag = true;
        this.resultValue = this.searchValue;
      } else {
        this.resultFlag = false;
      }
      const { rows, total } = await get("lib/book/list", params).catch(
        () => {}
      );
      this.dataList = rows;
      this.total = total;
    },
    goPage(url) {
      this.$router.push(url);
    },
  },
  created() {
    this.loadList();
  },
};
</script>

<style scoped lang="scss">
// ::v-deep .el-select .el-input__inner {
//   border: 0;
// }
// ::v-deep .el-select .el-input__inner:focus {
//   border: 0;
// }
::v-deep .pagination-container {
  margin-top: 0;
}
::v-deep .search_banner .el-input__inner:focus {
  border: 0;
}
::v-deep .search_banner .el-input__inner {
  border: 0;
}

.book-content {
  position: relative;
}

.banner_img {
  height: 220px;
  overflow: hidden;
  position: relative;
  img {
    // position:absolute;
    // top: -200px;
    // height: 600;
    // width: 100%;
  }
}
.search_banner {
  width: 100%;
  height: 110px;
  overflow: hidden;
  // position: absolute;
  // top: 150px;
  background-size: 100%;
  .search_group {
    display: flex;
    box-sizing: border-box;
    max-width: 900px;
    margin: 30px auto 0;
    height: 48px;
    width: 100%;
    background: #fff;
    border-radius: 4px;
    .search_left {
      width: 90%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding: 4px 20px;
      border: 1px solid #dcdfe6;
    }
    .search_right {
      cursor: pointer;
      width: 100px;
      height: 48px;
      line-height: 48px;
      text-align: center;
      background-color: #004796;
      color: #fff;
      font-size: 14px;
    }
    .search_right:hover {
      background-color: #0150aa;
    }
  }
}

.container {
  width: 100%;
  .bookContainer {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding-bottom: 30px;
    .search_tip {
      display: flex;
      justify-content: space-between;
      margin: 10px 0 0 0px;
      .total {
        line-height: 32px;
        font-size: 14px;
      }
      .page {
        margin-left: auto;
      }
    }
    .empty {
      text-align: center;
      padding: 36px;
      background-color: #fff;
      margin-top: 15px;
    }
    .book {
      background-color: #f7f7f7;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      padding: 36px;
      margin-top: 15px;
      .bookItem {
        cursor: pointer;
        padding: 0 18px;
        width: 20%;
        height: 400px;
        margin-bottom: 20px;
        .imgBox {
          width: 170px;
          height: 240px;
          padding-top: 20px;
          text-align: center;
          img {
            height: 100%;
            width: 100%;
            border: 0;
          }
        }
        .infoBox {
          padding: 15px 2px 0;
          .title {
            height: 44px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            word-break: break-all;
            color: #094d99;
            font-size: 14px;
            font-weight: 700;
          }
          .isbn {
            color: rgb(29, 126, 183);
            font-size: 14px;
          }
          p {
            color: #999;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
      .bookItem:hover .title {
        color: #1981f8;
      }
      .bookItem:last-child {
        margin-right: auto;
      }
      .info .info-item {
        padding: 4px 0px;
        font-size: 12px;
      }
    }
  }
}
</style>
